 import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

// We can follow the exemple of this file /src/modules/admin/archiving/containers/formHandlers/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsFormMeta.ts

export interface IConsultationDetailsFormMeta {
  transactionCode: FormInputMeta,
  destinationBin: FormInputMeta,
  reasonCode: FormInputMeta,
  accountNumber: FormInputMeta,
  sourceBin: FormInputMeta,
  //
  sourceAmount: FormInputMeta,
  sourceCurrencyCode: FormInputMeta, 
  destinationAmount: FormInputMeta,   
  destinationCurrencyCode: FormInputMeta,
  //
  processingDate: FormInputMeta,
  eventDate: FormInputMeta,
  transactionIdentifier: FormInputMeta,
  settlementFlag: FormInputMeta,
  message: FormInputMeta,
  //
  schema: any;
}

const ConsultationDetailsFormMeta = {} as IConsultationDetailsFormMeta;

ConsultationDetailsFormMeta.transactionCode = {
  name: 'transactionCode',
  type: 'text',
  label: 'Code transaction',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.accountNumber = {
  name: 'accountNumber',
  type: 'text',
  label: 'N° compte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.destinationBin = {
  name: 'destinationBin',
  type: 'text',
  label: 'BIN Destination',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.sourceBin = {
  name: 'sourceBin',
  type: 'text',
  label: 'BIN source',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.reasonCode = {
  name: 'reasonCode',
  type: 'text',
  label: 'Code motif',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

//

ConsultationDetailsFormMeta.sourceAmount = {
  name: 'sourceAmount',
  type: 'text',
  label: 'Montant source',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.sourceCurrencyCode = {
  name: 'sourceCurrencyCode',
  type: 'text',
  label: 'Code devise source',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.destinationAmount = {
  name: 'destinationAmount',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.destinationCurrencyCode = {
  name: 'destinationCurrencyCode',
  type: 'text',
  label: 'Code devise destination',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

//

ConsultationDetailsFormMeta.processingDate = {
  name: 'processingDate',
  type: 'date',
  label: 'Date de traitement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.eventDate = {
  name: 'eventDate',
  type: 'text',
  label: 'Date d\'évènement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.transactionIdentifier = {
  name: 'transactionIdentifier',
  type: 'text',
  label: 'ID Transaction',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.settlementFlag = {
  name: 'settlementFlag',
  type: 'text',
  label: 'Drapeau de reglement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ConsultationDetailsFormMeta.message = {
  name: 'message',
  type: 'textarea',
  label: 'Message',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultationDetailsFormMeta.schema = yup.object().shape(getValidationSchema(ConsultationDetailsFormMeta));

export default ConsultationDetailsFormMeta;